import React from 'react';
import { useParams } from 'react-router-dom';
import ArticleLayout from '../components/articles/ArticleLayout';

const Article = () => {
  const { id } = useParams();
  return <ArticleLayout articleId={id} />;
};

export default Article;
